import { isSection } from 'crm-cards-sdk/types/CrmContainerNode';
const isValidNode = node => {
  // filter out sections with no contents so users don't see them in the UI
  // this is not common but can be achieved by users not having access to the
  // section's contents, either through scopes/gates or by conditional logic
  return !(isSection(node) && node.contents.length === 0);
};
export function buildRecursiveCrmLocationAdapter({
  transformCard,
  partiallyTransformContainer,
  partiallyTransformLocation,
  isCard
}) {
  return data => {
    if (!data) {
      return undefined;
    }
    const partialCrmLocationConfig = partiallyTransformLocation(data);
    const transformContainer = container => {
      const partialContainer = partiallyTransformContainer(container);
      return Object.assign({}, partialContainer, {
        contents: partialContainer.contents.map(cardOrContainer => {
          if (isCard(cardOrContainer)) {
            return transformCard(cardOrContainer);
          }
          return transformContainer(cardOrContainer);
        }).filter(isValidNode)
      });
    };
    return Object.assign({}, partialCrmLocationConfig, {
      container: transformContainer(partialCrmLocationConfig.container)
    });
  };
}